import React from "react";
import { Link } from "react-router-dom";

function Startermenu() {
  return (
    <>
      <section className="menu-two">
        <div className="auto-container">
          <div className="title-box centered">
            <h2>TOPPING</h2>
          </div>
          <div className="row clearfix">
            <div className="menu-col col-lg-6 col-md-12 col-sm-12">
              <div className="inner">
                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Homemade pork chashu</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$5.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Homemade chicken chashu</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$5.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Katsu Chashu</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$7.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Spicy ground pork</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$5.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">
                            Ajitama
                            <span className="s-info">
                              MARINATED SOFT BOILED EGG
                            </span>
                          </Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$4.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">
                            Kaedama<span className="s-info">EXTRA NOODLE</span>
                          </Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$5.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Homemade pork broth</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$9.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Homemade chicken broth</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$7.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">homemade soy Vegan broth</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$9.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">homemade curry broth</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$9.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Seared Giant River Shrimp</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$8.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Seasoned Squid</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$5.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Scallion</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$3.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Seasoned Menma</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$4.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Kikurage</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$3.00</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="menu-col col-lg-6 col-md-12 col-sm-12">
              <div className="inner">
                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Seasoned Cabbage</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$3.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Bok Choy</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$2.50</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">
                            Avocado<span className="s-info">3 PCS.</span>
                          </Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$3.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Bean Sprout</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$2.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Corn</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$2.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Red Ginger</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$2.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Cilantro</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$2.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">
                            Seared Tofu<span className="s-info">5 PCS.</span>
                          </Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$4.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">
                            Fried Wonton Skin
                            <span className="s-info">2 PCS.</span>
                          </Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$2.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">
                            Nori<span className="s-info">3 PCS.</span>
                          </Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$2.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Shallot Chip</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$2.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Butter</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$2.00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Homemade Spicy Paste</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$2.50</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Homemade Spicy Oil</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$2.50</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="topping-block">
                  <div className="inner-box">
                    <div className="title clearfix">
                      <div className="ttl clearfix">
                        <h5>
                          <Link to="#">Homemade Black Garlic Oil</Link>
                        </h5>
                      </div>
                      <div className="price">
                        <span>$2.50</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Startermenu;
